<template>
  <div class="generate-ppt">
    <h1>生成PPT</h1>
    <p>这里是生成PPT的内容。</p>
  </div>
</template>

<script>
export default {
  name: 'GeneratePPT'
}
</script>

<style scoped>
.generate-ppt {
  padding: 20px;
}
</style>
